import { Injectable } from '@angular/core';
import { take } from 'rxjs/operators';
import { FeatureTogglesFacade } from '@cigna/shared/angular/features-feature';
import { AppStateGateway } from '@cigna/cigna-for-brokers/shared/gateways';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
  providedIn: 'root',
})
export class TrainingEducationService {
  apiUrl: string;

  isOktaLoginEnabled$ = this.featureTogglesFacade.featuresEnabled([
    'isOktaLoginEnabled',
  ]);
  constructor(
    private _gw: AppStateGateway,
    private featureTogglesFacade: FeatureTogglesFacade,
    private translate: TranslateService,
  ) {}
  redirectToExtUrl(extUrl: string, target: string) {
    this.isOktaLoginEnabled$
      .pipe(take(1))
      .subscribe((isOktaLoginEnabled: boolean) => {
        const isOktaExtRedirectUrl = this.translate.instant(
          `global.isOktaExtRedirectUrl`,
        );
        if (isOktaLoginEnabled && isOktaExtRedirectUrl === 'true') {
          const oktaExtRedirect = this._gw.getOktaExtRedirect(extUrl);
          window.open(oktaExtRedirect, target);
        } else {
          window.open(extUrl, target);
        }
      });
  }

  getOnDemandExploreContent() {
    this.redirectToExtUrl(this._gw.getOnDemandExploreContent(), '_blank');
  }
  getContinuingEdExploreCatalog() {
    this.redirectToExtUrl(this._gw.getContinuingEdExploreCatalog(), '_blank');
  }
  getContinuingEdExploreCatalogNew() {
    this.redirectToExtUrl(
      this._gw.getContinuingEdExploreCatalogNew(),
      '_blank',
    );
  }
}
